import React, { useContext } from 'react';

import { CustomModal } from '@shared/ui';

import { Context } from '../Accounts';
import cls from './AccountModal.module.css';
import { ModalAdd } from './ModalAdd/ModalAdd';
import { ModalEdit } from './ModalEdit/ModalEdit';

export const AccountModal = ({ onShowModal }) => {
    const { modalState } = useContext(Context);
    const { mode, isOpen } = modalState;

    return (
        <CustomModal contentClasses={cls.AccountModal} isOpen={isOpen} onHideModal={onShowModal}>
            {isOpen && (
                <>
                    {mode === 'add' ? (
                        <ModalAdd onShowModal={onShowModal} />
                    ) : (
                        <ModalEdit onShowModal={onShowModal} />
                    )}
                </>
            )}
        </CustomModal>
    );
};
